module.exports = __webpack_public_path__ + "static/media/icon-sidebar-pipelines.273116e0.svg";